// src/services/apiClient.js

import axios from 'axios';

const createApiClient = () => {
  const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  apiClient.interceptors.request.use(
    (config) => {
      const apiKey = process.env.REACT_APP_API_KEY;
      if (apiKey) {
        config.headers['X-API-KEY'] = apiKey;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  return apiClient;
};

export default createApiClient;
